/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Titulo_Dos_Datos from "../../Modulo_Graficas/Componentes/Titulos/Titulo_Dos_Datos";
import Tarjeta_Valor_Titulo_Grafica from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Valor_Titulo_Grafica";
import Area_Limpia from "../../Modulo_Graficas/Graficas/Area_Limpia";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {CASILLA_FECHA_DATO} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import React, {useContext, useEffect, useRef, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Despacho from "../Dialogos/Dialogo_Despacho";
import {usuarioContext} from "../../App";
import Tarjeta_Indicador from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Indicador";
import ic_caja from "../../Recursos/ic_caja.svg";
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {where} from "firebase/firestore";
import {arrConteoColSemanasAtras} from "../../Servicios/BD/Contadores_Arr/arrConteoColSemanasAtras";
import {ManageSearch} from "@mui/icons-material";

const Seccion_Despachos = () => {
    const refe = useRef()
    const {alto} = useObtenerAlto({contenedor: refe})
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'despachos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Despacho,
        titulo: 'Detalles Despacho',
        realizado: cargarNuevamente
    })
    const {usuario} = useContext(usuarioContext)
    const [numDespachosMes, setNumDespachosMes] = useState(0)
    const [numDespachosHoy, setNumDespachosHoy] = useState(0)
    const [despachosMes, setDespachosMes] = useState([])

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    useEffect(() => {

        let fechaHoy = new Date()
        const w = [where('fecha', '>', new Date(fechaHoy.getFullYear(), fechaHoy.getMonth(), 1).getTime())]
        contarWheres({coleccion: 'despachos', wheres: w}).then((dox) => {
            if (dox.res) {
                setNumDespachosMes(dox.data)
            }
        })

        const wHoy = [where('fecha', '>', new Date(fechaHoy.getFullYear(), fechaHoy.getMonth(), fechaHoy.getDate(), 0, 1).getTime())]
        contarWheres({coleccion: 'despachos', wheres: wHoy}).then((dox) => {
            if (dox.res) {
                setNumDespachosHoy(dox.data)
            }
        })

        arrConteoColSemanasAtras({coleccion: 'despachos', semanasAtras: 4}).then((arr) => {
            setDespachosMes(arr)
        })

    }, []);
    return (

        <Grid2 container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <Grid2 ref={refe} container size={{xs: 12, sm: 12, md: 8}}>
                    <Titulo_Dos_Datos coleccion={'despachos'} titulo={'Despachos'} usuario={usuario}
                                      datoUno={props.numeroFilas} datoTres={numDespachosMes}/>
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 6, md: 2}} sx={{height: alto}}>
                    <Tarjeta_Indicador icono={ic_caja} color={'#004438'} titulo={'Despachos hoy'}
                                       valor={numDespachosHoy}/>
                </Grid2>

                <Grid2 container size={{xs: 6, sm: 3, md: 2}} sx={{height: alto}}>
                    <Tarjeta_Valor_Titulo_Grafica valor={numDespachosMes}
                                                  titulo={'Despachos mes'}
                                                  Grafica={Area_Limpia}
                                                  series={
                                                      [{
                                                          name: 'Despachos',
                                                          data: despachosMes.map((it) => it.cantidad)
                                                      }]
                                                  }
                                                  labels={despachosMes.map((it) => it.nombre)}/>
                </Grid2>


                <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{marginTop: {xs: -18, sm: 0}}}>
                    <Tabla_Filtro
                        nombre={'Lista de despachos'}
                        descripcion={`${props.numeroFilas} despacho en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default Seccion_Despachos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Salida',
        direccion: 'left',
        propiedad: 'dato',
        fecha: 'fechaSalida',
        tipo: CASILLA_FECHA_DATO

    },
    {
        nombre: 'Llega a Destino',
        direccion: 'left',
        propiedad: 'ciudad',
        fecha: 'fechaLlegada',
        tipo: CASILLA_FECHA_DATO
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]